import React from 'react';

const Loading = () => (
  <div>
    <h1>Loading</h1>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js